<template>
    <AGCCard class="status-card">
      <div class="status-card__toolbar">
        <span v-if="$route.name === 'EditMerchant'">最後登入時間: {{ lastLoginTime }}</span>
        <span v-else>最新狀態</span>
        <a v-if="!hideCheckStatus" @click="historyModal = true">查看紀錄</a>
      </div>
      <div class="status-card__body">
        <img :src="require(`../assets/img/status-icn_${couponStatus.value}@3x.png`)"
             :alt="status.status"
        >
        <div>
          <span class="status-card__title">
            {{ couponStatus.text }}
            <span v-if="refundRemark" class="refund-remark">商戶退款處埋: {{ refundRemark }}</span>
          </span>
          <span class="status-card__subtitle">{{ message }}</span>
          <span class="status-card__subtitle" v-if="lastUpdateTimeWithoutSecond">
            更新時間: {{ lastUpdateTimeWithoutSecond }}
          </span>
        </div>
      </div>
      <StatusHistoryModal v-model="historyModal" :id="id" :statusType="statusType">
        <template v-slot:header>
          <slot name="header"></slot>
        </template>
      </StatusHistoryModal>
    </AGCCard>
</template>

<script>
import StatusHistoryModal from '@/components/StatusHistoryModal.vue';
import AGCCard from '@/components/AGCCard.vue';
import getCouponStatus, { getStatusRemarks, getPaymentCouponStatus } from '@/helpers/coupon-status';

export default {
  components: {
    AGCCard,
    StatusHistoryModal,
  },
  props: {
    status: String,
    id: [Number, String],
    hideCheckStatus: {
      type: Boolean,
      default: false,
    },
    statusType: {
      type: String,
      default: '',
    },
    lastUpdateTime: {
      type: String,
      default: '',
    },
    lastLoginTime: {
      type: String,
      default: '',
    },
    refundRemark: String,
  },
  data: () => ({
    historyModal: false,
  }),
  computed: {
    couponStatus() {
      if (this.statusType === 'PaymentCoupon') {
        return getPaymentCouponStatus(this.status);
      }
      return getCouponStatus(this.status);
    },
    message() {
      return getStatusRemarks(this.status);
    },
    lastUpdateTimeWithoutSecond() {
      return this.lastUpdateTime.substring(0, 16);
    },
  },
};
</script>

<style scoped lang="scss">
.status-card {
  &__toolbar {
    display: flex;
    justify-content: space-between;
    padding: 10px 20px;
    background: #318ce1;
    color: white;
    font-size: 15px;
    font-weight: 500;

    & a {
      cursor: pointer;
    }
  }

  &__body {
    display: flex;
    align-items: center;
    padding: 16px;

    & > img {
      width: 46px;
      height: 46px;
    }

    & > div {
      display: flex;
      flex-direction: column;
      margin-left: 16px;
    }
  }

  &__title {
    color: #3a4047;
    font-weight: 500;
    display: inline-flex;
    align-items: center;;
  }

  &__subtitle {
    color: #636D77;
    font-size: 14px;
  }

  .refund-remark {
    color: #4d7cb2;
    font-size: 0.85rem;
    margin-left: 4px;
  }
}
</style>
